export default "__VITE_ASSET__DfaxTvoH__"